<template>
  <IQOS :title="$t('regional_panel.title')" :enabled="editing" required>
    <p class="qrw-label-sm bold mt-16 iqos-comment v1-grey-7-color">
      {{ $t("regional_panel.currency") }}
    </p>
    <BaseSelect
      class="w-100 mt-8"
      v-model="edit_fields.currency_id"
      :disabled="!editing"
      v-if="available_currencies.length"
    >
      <option
        :value="item._id"
        v-for="item in available_currencies"
        :key="item._id"
      >
        {{ item.symbol }} | {{ item.name }}
      </option>
    </BaseSelect>
    <!-- <RoundCheckbox :readonly="!editing" class="iqos-element-item" v-model="edit_fields.round_menu_prices">
      {{ $t('regional_panel.round_menu_prices') }}
    </RoundCheckbox> -->
    <p class="qrw-label-sm bold mt-16 iqos-comment v1-grey-7-color">
      {{ $t("regional_panel.timezone") }}
    </p>
    <BaseSelect
      class="w-100 mt-8"
      v-model="edit_fields.timezone"
      :disabled="!editing"
    >
      <option
        :value="item"
        v-for="(item, index) in availableTimezones"
        :key="item + index"
      >
        {{ item }}
      </option>
    </BaseSelect>
    <p class="qrw-label-sm bold mt-16 iqos-comment v1-grey-7-color">
      {{ $t("regional_panel.language") }}
    </p>
    <BaseSelect
      class="w-100 mt-8"
      :disabled="!editing"
      v-model="edit_fields.language"
    >
      <option value="uk">Українська</option>
      <option value="ru">Русский</option>
      <option value="en">English</option>
    </BaseSelect>

    <template #actions>
      <IQOSActions 
        v-model="editing"
        @accept="onEditFinish"/>
    </template>
  </IQOS>
</template>

<script>

import CurrencyAPI from "@/api/currency";
import Timezones from "@/assets/timezones.json";

export default {
  data() {
    return {
      editing: false,

      edit_fields: {
        timezone: "Europe/Kiev",
        currency_id: null,
        language: null,
        round_menu_prices: false
      },

      available_currencies: [],
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    reset() {
      this.edit_fields.timezone = this.cafe.timezone;
      this.edit_fields.currency_id = this.cafe.currency_id;
      this.edit_fields.language = this.cafe.notifications_language;
      this.edit_fields.round_menu_prices = this.cafe.round_menu_prices || false;
    },
    onEditFinish() {
      this.$store.commit('patchCafeGeneralData', {
        currency_id: this.edit_fields.currency_id,
        timezone: this.edit_fields.timezone,
        notifications_language: this.edit_fields.language
      })
  
      this.$store.dispatch("saveCafe");

      this.$store.dispatch("auditlog/write", {
        type: "regional_settings",
        payload: this.edit_fields,
      });

      this.editing = false;
    },
    fetchCurrencies() {
      CurrencyAPI.getAll()
        .then((data) => {
          this.available_currencies = data.currencies;
          this.reset();
        })
        .catch((error) => {
          this.$store.dispatch("showError", "currency_error");
        });
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    availableTimezones() {
      return Timezones;
    },
  },
  mounted() {
    this.fetchCurrencies();
  }
};
</script>

<style>
</style>